export default __webpack_public_path__ + "static/media/rose-green.75e34db6.svg";